export default __webpack_public_path__ + "fonts/Roboto-300-latin7.woff2";